(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/models/storage-coupon.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/models/storage-coupon.js');

'use strict';

svs.maltipset.models.StorageCoupon = Backbone.Model.extend({
  product: 'Maltipset',
  initialize: function() {
    var fromStorage = svs.components.Storage.browser.get(
      svs.maltipset.constants.STORAGE_ID,
      this.product
    );

    if (fromStorage) {
      fromStorage.empty = false;
      if (
        !fromStorage.drawNumber &&
          svs.maltipset.collections.draws &&
          svs.maltipset.collections.draws.getFirstDraw()
      ) {
        var draw = svs.maltipset.collections.draws.getFirstDraw();
        fromStorage.drawNumber = draw.get('drawNumber');
        fromStorage.cancelCloseTime = draw.get('cancelCloseTime');
      }
      this.set(fromStorage);
    } else {
      this.set('empty', true);
    }

    if (
      this.hasData() &&
        !_.isUndefined(this.get('drawNumber')) &&
        _.isUndefined(
          svs.maltipset.collections.draws.getDraw(this.get('drawNumber'))
        )
    ) {
      this.empty();
    }

    this.listenTo(this, 'change', this.saveToLocalStorage, this);
  },
  hasData: function() {
    return !this.get('empty');
  },
  empty: function() {
    svs.components.Storage.browser.remove(
      svs.maltipset.constants.STORAGE_ID,
      this.product
    );
    this.clear();
    this.set(this.defaults(), { silent: true });
  },
  getSelectedMatchIndexes: function() {
    var matchIndexes = [];

    if (this.get('selectedMatches')) {
      _.each(this.get('selectedMatches'), function(row) {
        var emptyArray = [];
        for (var i = 0; i < svs.maltipset.constants.NUMBER_OF_MATCHES; i++) {
          emptyArray.push(row.indexOf(i + 1) >= 0 ? 1 : 0);
        }
        matchIndexes.push(emptyArray);
      });
      return matchIndexes;
    }
    return undefined;
  },
  storeSelectedMatches: function(drawNumber, system, selectedMatches) {
    var storageObject = {
      drawNumber: drawNumber,
      selectedMatches: selectedMatches,
      system: system
    };

    svs.maltipset.models.storageCoupon.set(storageObject, { silent: true });
    this.saveToLocalStorage();
  },
  saveToLocalStorage: function() {
    var expires = this.get('cancelCloseTime') ? new Date(this.get('cancelCloseTime')) : undefined;

    svs.components.Storage.browser.set(
      svs.maltipset.constants.STORAGE_ID,
      this.product,
      this.toJSON(),
      expires
    );
  },
  defaults: function() {
    return {
      empty: true,
      system: svs.maltipset.constants.SYSTEM.NO_SYSTEM,
      sportkryssBet: {},
      numWeeks: 1
    };
  }
});


 })(window);